import type {
  AdminContentSeries,
  AdminContentSeriesResponse,
  ContentSeriesAdminFields,
  ContentSeriesAdminFieldsBody,
} from '../types';

export function mapAdminContentSeries(data: AdminContentSeriesResponse): AdminContentSeries {
  return {
    id: data.id,
    title: data.title,
    handle: data.handle,
    imageUrl: data.image_url,
    premiumType: data.premium_type,
    isFeatured: data.is_featured,
    isVisible: data.is_visible,
    parentId: data.parent_id,
    parentTitle: data.parent_title,
    childrenCount: data.children_count,
    destroyed: data.destroyed,
    createdAt: data.created_at,
    artist: data.artist,
  };
}

/** camelCase fields -> wire body, keeping only the keys that were provided. */
export function mapContentSeriesAdminFieldsToBody(fields: ContentSeriesAdminFields): ContentSeriesAdminFieldsBody {
  /* eslint-disable camelcase */
  const body: ContentSeriesAdminFieldsBody = {
    premium_type: fields.premiumType,
    is_featured: fields.isFeatured,
    handle: fields.handle,
    parent_id: fields.parentId,
    default_artist_id: fields.defaultArtistId,
    rss_feed_url: fields.rssFeedUrl,
    consumption_mode: fields.consumptionMode,
    display_as_tiles: fields.displayAsTiles,
    seo_title: fields.seoTitle,
    og_title: fields.ogTitle,
    og_description: fields.ogDescription,
    og_twitter_title: fields.ogTwitterTitle,
  };
  /* eslint-enable camelcase */

  return Object.fromEntries(
    Object.entries(body).filter(([, value]) => value !== undefined)
  ) as ContentSeriesAdminFieldsBody;
}
